export default __webpack_public_path__ + "static/media/img9.728a3d58.jpg";